<template>
	<div class="modal-delete-tag-container delete-team-container">
		<span class="modal-times" @click="onClose">&times;</span>
		<template v-if="showDeleting">
			<h5
				class="modal-delete-team-title text-white"
			>
				{{ $tc('modals.deleteTeamConfirm.title') }}
			</h5>
			<div class="modal-delete-team-body">
				<div class="modal-delete-team-content" v-html="$tc('modals.deleteTeamConfirm.mainText')" />
				<div class="confirm-fld-wrap">
					<label for="confirm-team-type">{{ $t('modals.deleteTeamConfirm.typeText', {typeText: confirmText}) }}</label>
					<div class="form-element-wrap">
						<input id="confirm-team-type" v-model="confirmTypeText" type="text">
					</div>
				</div>
			</div>
			<div class="modal-delete-team-buttons flex flex-center">
				<button class="button-delete font-regular font-uppercase text-black mr-5 flex-center" :disabled="disableConfirm" @click="confirmHandler">
					{{ $tc('profile.teams.deleteTeam.title') }}
				</button>
				<button class="button-light-blue font-regular font-uppercase text-black ml-5 flex-center" @click="onClose">
					{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
				</button>
			</div>
		</template>
		<div v-if="isCreateTeam && !showDeleting" class="create-team-wrap">
			<h5 class="modal-delete-team-title text-white">
				{{ $tc('modals.deleteTeamConfirm.createTitle') }}
			</h5>
			<div class="modal-delete-team-body">
				<div class="modal-delete-team-content">
					{{ $tc('modals.deleteTeamConfirm.createTeamText') }}
				</div>
				<add-team-form :teams="options.teams" :auto-save="saveTeam" @success="onConfirm" @error="saveTeam = false" />
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import AddTeamForm from '~/components/forms/AddTeamForm'

export default {
	name: 'ModalDeleteTeamConfirm',
	components: { AddTeamForm },
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			confirmText: 'DELETE TEAM',
			confirmTypeText: '',
			saveTeam: false,
			showDeleting: true
		}
	},
	computed: {
		disableConfirm () {
			return this.confirmText !== this.confirmTypeText.toUpperCase()
		},
		isCreateTeam () {
			return this.options.ownTeamsCount === 1
		}
	},
	methods: {
		confirmHandler () {
			if (this.isCreateTeam) {
				this.saveTeam = true
				this.showDeleting = false
			} else {
				this.onConfirm()
			}
		}
	}
}
</script>

<style lang="scss">
$color-red: #d25252;
$color-gray: #939b9b;
.modal-overlay .delete-team-container {
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 606px;
	padding: 46px 37px 38px 32px;
	background-color: #252D31;
	.modal-times {
		position: absolute;
		right: 19px;
		top: 15px;
		color: #fff;
		opacity: 0.8;
		cursor: pointer;
		font-size: 32px;
		line-height: 32px;
		font-weight: 100;
		&:hover {
			opacity: 1;
		}
	}
	.modal-delete-team-title {
		letter-spacing: 1.2px;
		font-weight: 600;
		@include respond-below(phone) {
			font-size: 18px;
		}
	}
	.modal-delete-team-body {
		color: #fff;
		padding-top: 20px;
		font-size: 14px;
		line-height: 22px;
	}
	.modal-delete-team-content {
		padding-right: 40px;
		margin-bottom: 31px;
		@include respond-below(phone) {
			padding-right: 0;
		}
	}
	.confirm-fld-wrap {
		label {
			display: block;
			font-size: 15px;
			margin-bottom: 4px;
		}
	}
	.modal-delete-team-buttons {
		padding-top: 50px;
		gap: 24px;
		@include respond-below(phone) {
			flex-direction: column;
		}
	}
	button {
		height: 50px;
		line-height: 50px;
		border-radius: 25px;
		background-color: transparent;
		font-weight: 600;
		font-size: 16px;
		text-transform: uppercase;
		padding: 0;
		letter-spacing: 1px;
		width: 50%;
		max-width: 260px;
		min-width: 190px;
		transition: all .2s ease;
		margin: 0;
		&.button-delete {
			border: 1px solid $color-red;
			color: $color-red;
			&:hover {
				color: #fff;
				background-color: $color-red;
			}
		}
		&.button-light-blue {
			border: 1px solid $color-gray;
			color: $color-gray;
			&:hover {
				color: #fff;
				background-color: $color-gray;
			}
		}
	}
}

.form-element-wrap input {
	background: rgba(147, 155, 155, .4);
	border: 1px solid transparent;
	border-radius: 8px;
	height: 48px;
	color: #fff;
	width: 100%;
	font-size: 14px;
	font-family: Comfortaa, sans-serif;
	padding: 0 10px;
	outline: 0 none;
	&:focus {
		border-color: rgba(147, 155, 155, .8);
	}
}

.create-team-wrap .account-form {
	> div:last-child {
		margin-top: 50px;
	}
	.form-group {
		margin-bottom: 0;
	}
	.text-input-wrap {
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 10px;
		.text-input-label {
			color: #fff;
			text-transform: capitalize;
			font-size: 15px;
			margin-bottom: 4px;
			font-weight: 400;
			justify-content: flex-start;
			line-height: 18px;
		}
		.text-input-holder {
			margin-left: 0;
			max-width: none;
			width: 100%;
			.text-input {
				background-color: rgba(147, 155, 155, .4);
				border: 1px solid transparent;
				border-radius: 8px;
				height: 48px;
				width: 100%;
				font-size: 14px;
				color: #fff;
				font-family: Comfortaa, sans-serif;
				padding: 0 10px;
				outline: 0 none;
				&:focus {
					border-color: rgba(147, 155, 155, .8);
				}
				&[aria-invalid='true'],
				&::placeholder {
					color: rgba(255, 255, 255, 0.5);
				}
				option {
					color: #fff;
					background: rgb(147, 155, 155);
				}
			}
			select {
				background-image:
					linear-gradient(45deg, transparent 50%, rgba(255, 255, 255, 0.5) 50%),
					linear-gradient(135deg, rgba(255, 255, 255, 0.5) 50%, transparent 50%);
				background-position:
					calc(100% - 20px) 20px,
					calc(100% - 15px) 20px;
				background-size:
					5px 5px,
					5px 5px;
				background-repeat: no-repeat;
			}
		}
	}
}
</style>
